import { IsArray, IsBoolean, IsNotEmpty, IsOptional, Length, ValidateNested } from 'class-validator';
import { CreateSurveyQuestionDto } from './create-survey-quetion.dto';
import { Type } from 'class-transformer';

export class CreateSurveyTemplateDto {
	@IsOptional()
	@IsBoolean()
	adminTemplate?: boolean;

	@IsNotEmpty()
	@Length(1)
	title: string;

	@IsArray()
	@ValidateNested({ each: true })
	@Type(() => CreateSurveyQuestionDto)
	questions?: Array<CreateSurveyQuestionDto>;

	districtIds: Array<string> | string;
	isDefaultTemplate?: boolean;
}

export class CreateSurveyTemplateQuestionsDto {
	@IsArray()
	@ValidateNested({ each: true })
	@Type(() => CreateSurveyQuestionDto)
	questions?: Array<CreateSurveyQuestionDto>;
}
